let _logger = console; // eslint-disable-line no-console

/**
 * Set the logger to be used in the logging helper.
 */
function setLogger(newLogger) {
  _logger = newLogger;
}

/**
 * Helper function for injecting $log into ES6 style classes where AngularJS injection cannot
 * be used.
 *
 * Call `setLogger` in a run function to set the $log that is used.
 *
 * Before $log has been set, uses console as a fallback.
 *
 * @return {object} The current logging object, console or $log.
 */
function logger() {
  return _logger;
}

export {
  setLogger,
  logger
};
